<template>
  <div id="app" class="global-background">
    <SiteHeader />

    <main>
      <HeroSection />
      <EquifaxSection />
      <SobreEmpresa />
      <DiferenciaisBlock />
      <ServicosSection />
      <MissaoVisao />
      <CTASection />
    </main>

    <FooterSection />
    <WhatsAppFloat />

    <!-- Barra de rolagem visual fixa (overlay) -->

  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

import SiteHeader from "@/components/SiteHeader.vue";
import HeroSection from "@/components/HeroSection.vue";
import WhatsAppFloat from "@/components/WhatsAppFloat.vue";

const EquifaxSection = defineAsyncComponent(() => import("@/components/EquifaxSection.vue"));
const SobreEmpresa = defineAsyncComponent(() => import("@/components/SobreEmpresa.vue"));
const DiferenciaisBlock = defineAsyncComponent(() => import("@/components/DiferenciaisBlock.vue"));
const ServicosSection = defineAsyncComponent(() => import("@/components/ServicosSection.vue"));
const MissaoVisao = defineAsyncComponent(() => import("@/components/MissaoVisao.vue"));
const CTASection = defineAsyncComponent(() => import("@/components/CTASection.vue"));
const FooterSection = defineAsyncComponent(() => import("@/components/FooterSection.vue"));

export default {
  name: "App",
  components: {
    SiteHeader,
    HeroSection,
    EquifaxSection,
    SobreEmpresa,
    DiferenciaisBlock,
    ServicosSection,
    MissaoVisao,
    CTASection,
    FooterSection,
    WhatsAppFloat,
  },
};
</script>
<style>
.global-background {
  position: relative;
  background: var(--white);
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: visible; /* body é quem deve rolar */

  /* trava layout: footer sempre no final, sem “vazio” */
  display: flex;
  flex-direction: column;
}

main{
  flex: 1;
}
</style>